import React from "react";
import Logo from "../images/logo.png";
import { AiOutlineHome } from "react-icons/ai";
import { SlUserFollowing } from "react-icons/sl";
import { HiOutlineBriefcase } from "react-icons/hi";
import { PiGraduationCap } from "react-icons/pi";
import { LuLayers } from "react-icons/lu";
import { BiMessage } from "react-icons/bi";
import { GiSkills } from "react-icons/gi";

const Sidebar = ({menuBar,setMenuBar}) => {
  // const [activeNav, setActiveNav] = useState(true);

  return (
    <aside className={menuBar ? "aside" : "aside show"}>
      <a href="#home" className="logo" onClick={() => setMenuBar(true)}>
        <img src={Logo} alt="logo" />
      </a>

      <ul className="navlinks">
        <li className="navitem">
          <a href="#home" className="navlink" onClick={() => setMenuBar(true)}>
            <AiOutlineHome className="navIcon" />
            Home
          </a>
        </li>

        <li className="navitem">
          <a href="#about" className="navlink" onClick={() => setMenuBar(true)}>
            <SlUserFollowing className="navIcon" />
            About
          </a>
        </li>

        <li className="navitem">
          <a href="#services" className="navlink" onClick={() => setMenuBar(true)}>
            <HiOutlineBriefcase className="navIcon" /> Services
          </a>
        </li>

        <li className="navitem">
          <a href="#skills" className="navlink" onClick={() => setMenuBar(true)}>
            <GiSkills className="navIcon" /> Skills
          </a>
        </li>

        <li className="navitem">
          <a href="#education" className="navlink" onClick={() => setMenuBar(true)}>
            <PiGraduationCap className="navIcon" /> Education
          </a>
        </li>

        <li className="navitem">
          <a href="#portfolio" className="navlink" onClick={() => setMenuBar(true)}>
            <LuLayers className="navIcon" /> Portfolio
          </a>
        </li>

        {/* <li className="navitem">
          <a href="#blog" className="navlink">
            <GoProjectSymlink className="navIcon" /> Projects
          </a>
        </li> */}

        <li className="navitem">
          <a href="#contact" className="navlink" onClick={() => setMenuBar(true)}>
            <BiMessage className="navIcon" /> Contact
          </a>
        </li>
      </ul>

      <div className="side_footer">
        <span className="copyright">&copy; 2022 - 2023. </span>
      </div>
    </aside>
  );
};

export default Sidebar;
